import { Form, Button } from 'react-bootstrap';
import { ImageModel } from '../../data/entities';
import { Icon, IconAndText, IconDefinitions } from '../icons';
import { LinkLooksLike } from '../link';
import { useMediaUploader } from '../../hooks';

interface MediaUploaderProps {
  title?: string;
  hint?: string;
  previewImage: ImageModel | null;
  uploadHandler: (image: ImageModel) => Promise<void>;
  removeHandler: () => Promise<void>;
  onUploadSuccess?: () => void;
}

export function MediaUploader(props: MediaUploaderProps) {
  const {
    selectedImage,
    fileInputRef,
    handleFileChange,
    handleDeleteClick,
    handleUploadClick,
  } = useMediaUploader({
    uploadHandler: props.uploadHandler,
    removeHandler: props.removeHandler,
    onUploadSuccess: props.onUploadSuccess,
  });

  return (
    <div className="media-uploader mb-3">
      {props.title && (
        <Form.Label className="text-muted small fw-semibold text-uppercase ls-1 mb-2">
          {props.title}
        </Form.Label>
      )}

      <div className="media-uploader-box border rounded d-flex align-items-center gap-3 p-3 bg-body">
        {/* Avatar */}
        <div
          className="media-uploader-avatar rounded flex-shrink-0 border overflow-hidden bg-light d-flex align-items-center justify-content-center"
          style={{ width: 56, height: 56 }}
        >
          {props.previewImage ? (
            <img
              src={`data:image/jpeg;base64,${props.previewImage.data}`}
              alt={selectedImage?.name ?? props.previewImage.fileName}
              className="w-100 h-100 object-fit-cover"
            />
          ) : (
            <Icon iconName={IconDefinitions.person} className="text-secondary fs-4" />
          )}
        </div>

        {/* Filename */}
        <div className="flex-grow-1 overflow-hidden">
          {props.previewImage ? (
            <p className="mb-0 text-truncate small fw-semibold">
              {props.previewImage.fileName}
            </p>
          ) : (
            <p className="mb-0 small fw-semibold">No image selected</p>
          )}
          {props.hint && (
            <p className="mb-0 small text-body-secondary">{props.hint}</p>
          )}
        </div>

        {/* Actions */}
        <div className="d-flex align-items-center gap-2 flex-shrink-0">
          <Form.Group controlId="imageUpload" className="mb-0">
            <Button variant="outline-primary" size="sm" onClick={handleUploadClick}>
              <IconAndText iconName={IconDefinitions.upload} text="Upload" />
              <input
                type="file"
                accept="image/*"
                className="d-none"
                ref={fileInputRef}
                onChange={handleFileChange}
              />
            </Button>
          </Form.Group>

          {props.previewImage && (
            <LinkLooksLike onClick={handleDeleteClick} className="text-danger">
              <Icon iconName={IconDefinitions.close} />
            </LinkLooksLike>
          )}
        </div>
      </div>
    </div>
  );
}

export default MediaUploader;